import React, { useState, useEffect } from "react";
import image from "../../../../Resources/images/images.jpg";
import { MdClose, MdDelete, MdEdit } from "react-icons/md";
import Table from "../../../UI/Table/Table";
import axios from "../../../../HOC/CreateAxios/CreateAxios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import MasterDeleteModal from "../../../UI/Model/MasterDeleteModel/MasterDeleteModel";
function ViewCategory({ showCategory, searchText }) {
  const [Tbody, setTbody] = useState([]);
  const [message, setMessage] = useState(false);
  const [ID, setID] = useState("");
  const [storeID, setStoreID] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [storeImage, setStoreImage] = useState("");
  const [idStore, setIdStore] = useState(false);
  const FormInitial = [
    {
      label: "Category Name",
      apikey: "Category_name",
      placeholder: "Enter Category name here !",
      type: "text",
    },
    // {
    //   type: "file",
    //   apikey: "image",
    //   label: "image",
    //   placeholder: "image",
    //   // Images: [],
    //   accept: "image/*,.jpg,.png,.jpeg,.mov",
    // },
  ];
  const Schema = yup.object().shape({
    Category_name: yup.string().required("Category name is required"),
    // image: yup.string().required("Image is required"),
    // allData: yup.string().required("Email is required"),
  });
  const getCategory = () => {
    axios
      .get("/category")
      .then((res) => {
        console.log(res);
        setTbody(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getCategory();
  }, []);

  const tHead = [
    { title: "s.nO", width: "10%" },
    { title: "name", width: "20%" },
    // { title: "image", width: "20%" },
    { title: "action", width: "30%" },
  ];

  const Filter = (array) => {
    console.log(searchText);
    return array.filter(
      (option) =>
        option["Category_name"]
          .toLowerCase()
          .indexOf(searchText.toLowerCase()) > -1
    );
  };
  const DeleteItems = (id) => {
    // console.log(idStore);
    axios
      .delete(`category/${idStore}`)
      .then((res) => {
        if (res.status === 200) {
          getCategory(id);
          setMessage(false);
          console.log(res);
          toast.error(
            res ? res?.data?.message : "Category has been deleted sucessfully"
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const Conformation = (id) => {
    setMessage(true);
    setIdStore(id);
    // console.log(id);
  };

  useEffect(() => {
    getCategory();
  }, []);
  let ConformationMessage;
  if (message) {
    ConformationMessage = (
      <MasterDeleteModal
        id={idStore}
        Delete={DeleteItems}
        setMessage={setMessage}
      />
    );
  }
  const Edit = (values) => {
    setID(values);
    // setStoreImage(values?.image);
    // setStoreImage([...values.image]);

    setShowModel(true);
    // console.log(values);
    // setStoreImage([...values.image]);
  };
  console.log(ID);
  useEffect(() => {
    setStoreID(ID);
  }, [ID, storeID]);
  const Submits = (value) => {
    // value.details = storeDescription;
    // value.image = storeImage;
    // console.log(value);
    // let formData = new FormData();
    // formData.append("Brand_name", value.Brand_name);
    // formData.append("image", value.image);
    // storeImage.map((val, i) => {
    //   return formData.append("image", val);
    // });
    // value.name = ID.name;
    // value.tId = ID.tId;
    // value.createdAt = ID.createdAt;
    // console.log(value);
    axios
      .patch(`/category/${ID.id}`, value)
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          setShowModel(false);
          // setStoreDescription("");
          toast.info("Brand has been updated sucessfuly");
          getCategory();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleChange = (e) => {
    // alert("working");
    if (e.target.files.length !== 0) {
      setStoreImage(e.target.files[0]);
    }
  };
  let mod;
  mod = (
    <div
      className={`${
        showModel ? " absolute  z-50 top-0 bottom-0 right-0 left-0" : ""
      }`}
    >
      <div
        className={` ${
          showModel ? "translate-y-0 " : "-translate-y-full "
        }  duration-700 delay-300 ease-in-out fixed top-0 bottom-0 right-0 left-0  z-40 `}
      >
        <div
          className=" relative z-50 bg-[white] rounded-md top-[30%]  flex 
         p-5 w-[70%] mx-auto h-80 "
        >
          <div className="w-[95%] my-4">
            <Formik
              initialValues={{
                Category_name: ID?.Category_name ? ID?.Category_name : "",
                // image: ID?.image ? ID?.image : "",
              }}
              validationSchema={Schema}
              onSubmit={(values, { resetForm }) => {
                console.log(values);
                Submits(values);
                resetForm();
              }}
            >
              {({ values, errors, touched, handleSumit, isSubmitting }) => (
                <Form>
                  <div className={`   gap-6`}>
                    {FormInitial?.map((val, i) => {
                      if (val.type === "file") {
                        return (
                          <div key={i} className="full ">
                            <div className="capitalize  my-3">
                              <label
                                className="cursor-pointer text-gray-600 font-semibold"
                                htmlFor={val.apikey}
                              >
                                {val.label}
                              </label>
                            </div>

                            {/* <div className="grid grid-cols-12  space-x-1 gap-3 border p-1 h-64 "> */}
                            <label htmlFor="image">
                              <div className=" w-full">
                                <div className="w-full h-full  relative  p-1.5 overflow-hidden">
                                  <img
                                    src={
                                      storeImage
                                        ? URL.createObjectURL(storeImage)
                                        : `${process.env.REACT_APP_API_URL}/public/${ID?.image}`
                                    }
                                    alt="Loading..."
                                    className="object-cover mx-5 w-full h-96 object-top"
                                  />
                                </div>
                              </div>
                            </label>
                            {/* </div> */}
                            <input
                              id="image"
                              type={"file"}
                              accept={val.accept}
                              name={val.apikey}
                              onChange={(e) => handleChange(e)}
                              className="bg-white hidden relative z-50  outline-none rounded-sm 
                                    border-none px-2 py-1"
                            />
                            <div
                              className={`${
                                errors[val.apikey] && touched[val.apikey]
                                  ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                                  : ""
                              }`}
                            >
                              {errors[val.apikey] && touched[val.apikey]
                                ? errors[val.apikey]
                                : ""}
                            </div>
                          </div>
                        );
                      } else {
                        return (
                          <div key={i} className="full my-8 ">
                            <div className="capitalize  my-3">
                              <label
                                className="cursor-pointer text-gray-600 font-semibold"
                                htmlFor={val.apikey}
                              >
                                {val.label}
                              </label>
                            </div>
                            <div className="relative">
                              <Field
                                id={val.apikey}
                                placeholder={val.placeholder}
                                name={val.apikey}
                                className="border border-gray-300 px-3 py-2.5  w-11/12 laptop:w-full rounded-md"
                              />
                            </div>

                            <div
                              className={`${
                                errors[val.apikey] && touched[val.apikey]
                                  ? "text-xs text-red-500 py-[1px] px-2 mt-2 bg-red-50 w-full"
                                  : ""
                              }`}
                            >
                              {errors[val.apikey] && touched[val.apikey]
                                ? errors[val.apikey]
                                : ""}
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                  <div className="flex justify-start  mt-5 w-11/12">
                    <button
                      type="submit"
                      className="bg-green-600 text-white  font-bold capitalize px-5 py-2 rounded-md hover:bg-opacity-70 "
                    >
                      submit
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div
            className="absolute top-5 border border-gray-600  text-gray-600 bg-white  
            hover:bg-opacity-60  text-3xl rounded-full p-1 cursor-pointer right-10"
            onClick={() => {
              setShowModel(false);
              setID(null);
              setStoreImage("");
            }}
          >
            <MdClose />
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
  return (
    <div className=" p-6">
      <div
        className={`${
          showModel
            ? "fixed bg-black bg-opacity-10   overflow-auto  z-50 top-0 bottom-0 right-0 left-0"
            : ""
        } `}
      >
        <div
          className={` ${
            showModel ? "translate-y-0  " : "-translate-y-full  "
          }  duration-700 delay-300 ease-in-out   absolute top-0 bottom-0 right-0 left-0  z-40 `}
        >
          {showModel ? mod : ""}
        </div>
      </div>
      <Table celspacing={0} cellPadding={0} Head={tHead}>
        {Tbody?.map((val, i) => {
          return (
            <tr key={i} className=" w-full">
              <td className="border-b p-2 text-center border-l"> {i + 1}</td>
              <td className="border-b p-2 text-center">{val.Category_name}</td>
              {/* <td className="border-b flex justify-center items-center ">
                <div className={`my-3  w-36 h-36     `}>
                  <img
                    src={`${process.env.REACT_APP_API_URL}/${val.image}`}
                    alt="Loading..."
                    height={150}
                    width={150}
                    className="w-36 h-36"
                  />
                </div>
              </td> */}
              <td className="border-b p-2 text-center border-r">
                <div className="flex mx-3 gap-2 items-center justify-center">
                  {" "}
                  <div className="">
                    <button
                      className="border border-gray-600 rounded-md  hover:bg-blue-100 hover:text-blue-500 px-2 py-1"
                      onClick={() => Edit(val)}
                    >
                      <MdEdit className="text-2xl" />
                    </button>
                  </div>
                  <div className="">
                    <button
                      className=" capitalize border border-[#9a9a9a] px-2 py-1 rounded-md hover:bg-red-100  hover:text-red-500"
                      onClick={() => Conformation(val.id)}
                    >
                      <MdDelete className="text-2xl" />
                    </button>
                  </div>
                  {ConformationMessage}
                </div>
              </td>
            </tr>
          );
        })}
      </Table>
      <ToastContainer />
    </div>
  );
}

export default ViewCategory;
